import { MessageOutlined } from '@ant-design/icons'
import { ProviderClient } from '../../abstract/provider.client'
import { ProviderUIChatV2Common } from '../common'

export const ProviderUIChatClientV2: ProviderClient = {
  key: ProviderUIChatV2Common.key,
  description: {
    label: 'UI Chat V2',
    icon: <MessageOutlined />,
    triggers: [
      {
        key: 'NewMessage',
        label: 'New message',
        input: [
          { key: 'messageId', propsFormItem: { label: 'Message ID' } },
          {
            key: 'canEmit',
            type: 'boolean',
            propsFormItem: { label: 'Can emit' },
          },
        ],
        output: [
          {
            key: 'content',
          },
        ],
      },
      {
        key: 'NewConversation',
        label: 'New conversation',
        input: [
          {
            key: 'conversationId',
            propsFormItem: { label: 'Conversation ID' },
          },
        ],
        output: [
          {
            key: 'content',
          },
        ],
      },
    ],
    actions: [
      {
        key: 'sendMessage',
        label: 'Send message',
        input: [
          {
            key: 'content',
          },
        ],
        output: [],
      },
    ],
  },
}
